var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45","viewBox":"0 0 24 24","fill":"none","stroke":"#56C0EE","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 3v18h18"}}),_c('path',{attrs:{"d":"M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }